export const animationsConfig = {
  // 's2-coffee': [{
  //   delay: 0,
  //   duration: 0.02,
  //   from: {
  //     alpha: 0
  //   },
  //   to: {
  //     alpha: 1
  //   }
  // }],
  's2-rabbits': [{
    delay: 0.003,
    duration: 0.006,
    from: {
      alpha: 0
    },
    to: {
      alpha: 1
    }
  }],
  's2-dialog': [{
    delay: 0.01,
    duration: 0.01,
    from: {
      width: 0,
      height: 0,
      ease: Power1.easeIn
    }
  }],
  's3-hand': [{
    delay: 0.0233,
    duration: 0.02,
    from: {
      alpha: 0,
      ease: Power1.easeIn
    },
    to: {
      alpha: 1,
      ease: Power1.easeIn
    }
  }],
  's3-person': [{
    delay: 0.0233,
    duration: 0.02,
    from: {
      alpha: 0,
    },
    to: {
      alpha: 1,
    }
  }],
  's3-sound': [{
    delay: 0.057,
    duration: 0.03,
    from: {
      alpha: 0,
      repeat: 3
    }
  }],
  's3-rabbit1': [{
      delay: 0.0233,
      duration: 0.02,
      from: {
        alpha: 0,
      },
      to: {
        alpha: 1,
      }
    },
    {
      delay: 0.045,
      duration: 0.01,
      to: {
        alpha: 0
      }
    }
  ],
  's3-rabbit2': [
    {
      delay: 0.045,
      duration: 0.01,
      from: {
        alpha: 0
      },
      to: {
        alpha: 1
      }
    },
    {
      delay: 0.052,
      duration: 0.01,
      to: {
        alpha: 0
      }
    },
  ],
  's3-rabbit3': [
    {
      delay: 0.052,
      duration: 0.01,
      from: {
        alpha: 0
      },
      to: {
        alpha: 1
      }
    }
  ],
  's3-mouth1': [
    {
      delay: 0.051,
      duration: 0.01,
      to: {
        alpha: 0
      }
    }
  ],
  's3-mouth2': [
    {
      delay: 0.053,
      duration: 0.02,
      from: {
        alpha: 0
      },
      to: {
        alpha: 1
      }
    },
    {
      delay: 0.062,
      duration: 0.02,
      to: {
        alpha: 0
      }
    },
  ],
  's3-mouth3': [
    {
      delay: 0.066,
      duration: 0.02,
      from: {
        alpha: 0
      },
      to: {
        alpha: 1
      },
    },
    {
      delay: 0.075,
      duration: 0.02,
      to: {
        alpha: 0
      }
    },
  ],
  's3-mouth4': [
    {
      delay: 0.078,
      duration: 0.01,
      from: {
        alpha: 0
      },
      to: {
        alpha: 1
      }
    }
  ],
  's3-dialog1': [{
    delay: 0.1077,
    duration: 0.02,
    from: {
      alpha: 0,
      x: 2428
    }
  }],
  's3-dialog2': [{
    delay: 0.1178,
    duration: 0.02,
    from: {
      alpha: 0,
      x: 2960
    }
  }],
  's3-dialog3': [{
    delay: 0.138,
    duration: 0.02,
    from: {
      alpha: 0,
      x: 3174
    }
  }],
  's3-dialog4': [{
    delay: 0.159,
    duration: 0.02,
    from: {
      alpha: 0,
      x: 3640
    }
  }],
  's3-breeze2': [{
    delay: 0.152,
    duration: 0.02,
    from: {
      width: 0,
      height: 0
    }
  }],
  's3-breeze1': [{
    delay: 0.158,
    duration: 0.02,
    from: {
      width: 0,
      height: 0
    }
  }],
  's3-leaf1': [{
    delay: 0.162,
    duration: 0.02,
    from: {
      width: 0,
      height: 0
    }
  }, {
    delay: 0.164,
    duration: 0.06,
    to: {
      x: 4062,
      y: 790,
      ease: Power1.easeIn
    }
  }],
  's4-min': [{
    delay: 0.258,
    duration: 0.02,
    from: {
      // transformOrigin: 'top left'
    },
    to: {
      // transformOrigin: 'top left',
      rotation: Math.PI * 4,
      ease: Power1.easeInOut
    }
  }],
  's4-hour': [{
    delay: 0.258,
    duration: 0.02,
    from: {
    },
    to: {
      // transformOrigin: 'top left',
      rotation: Math.PI / 3,
      ease: Power1.easeInOut
    }
  }],
  's4-dialog': [{
    delay: 0.225,
    duration: 0.02,
    from: {
      x: 4937,
      y: 178,
      alpha: 0
    }
  }],
  's4-pop': [{
    delay: 0.266,
    duration: 0.03,
    from: {
      alpha: 0
    }
  }],
  's5-left-hand1': [{
    delay: 0.26,
    duration: 0.01,
    from: {
      alpha: 1
    },
    to: {
      alpha: 0
    }
  }, {
    delay: 0.29,
    duration: 0.01,
    to: {
      alpha: 1
    }
  }],
  's5-left-hand2': [{
    delay: 0.27,
    duration: 0.01,
    from: {
      alpha: 0
    },
    to: {
      alpha: 1
    }
  }, {
    delay: 0.28,
    duration: 0.01,
    to: {
      alpha: 0
    }
  }],
  's5-para': [{
    delay: 0.303,
    duration: 0.01,
    from: {
      alpha: 0
    }
  }],
  's5-rabbit': [{
    delay: 0.311,
    duration: 0.01,
    from: {
      alpha: 0
    }
  }],
  's5-dialog': [{
    delay: 0.321,
    duration: 0.01,
    from: {
      width: 0,
      height: 0
    }
  }],
  's6-dialog1': [{
    delay: 0.402,
    duration: 0.02,
    from: {
      x: 8052,
      alpha: 0,
      ease: Power1.easeIn
    }
  }],
  's6-dialog2': [{
    delay: 0.422,
    duration: 0.02,
    from: {
      x: 8096,
      alpha: 0,
      ease: Power1.easeIn
    }
  }],
  's6-dialog3': [{
    delay: 0.432,
    duration: 0.02,
    from: {
      x: 8250,
      alpha: 0,
      ease: Power1.easeIn
    }
  }],
  's6-dialog4': [{
    delay: 0.438,
    duration: 0.02,
    from: {
      alpha: 0,
      ease: Power1.easeIn
    }
  }],
  's6-bulb': [{
    delay: 0.454,
    duration: 0.02,
    from: {
      alpha: 0,
      ease: Power1.easeIn
    }
  }],
  's7-q1': [{
    delay: 0.483,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's7-q2': [{
    delay: 0.5,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's7-q3': [{
    delay: 0.485,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's7-q4': [{
    delay: 0.49,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's7-dialog': [{
    delay: 0.506,
    duration: 0.02,
    from: {
      width: 0,
      height: 0
    }
  }],
  's8-qa1': [{
    delay: 0.551,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's8-qa2': [{
    delay: 0.553,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's8-qa3': [{
    delay: 0.562,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's8-qb1': [{
    delay: 0.572,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's8-qb2': [{
    delay: 0.582,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's8-qb3': [{
    delay: 0.596,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's9-dialog1': [{
    delay: 0.635,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's9-dialog2': [{
    delay: 0.656,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's9-dialog3': [{
    delay: 0.664,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's10-pot': [{
    delay: 0.724,
    duration: 0.02,
    from: {
      x: 13561,
      yoyo: true,
      repeat: 4
    }
  }],
  's10-person': [{
    delay: 0.748,
    duration: 0.1,
    from: {
      x: 14440,
      ease: Power1.easeOut
    }
  }],
  's10-dialog': [{
    delay: 0.77,
    duration: 0.02,
    from: {
      x: 14344,
      alpha: 0,
      ease: Power1.easeOut
    }
  }],
  's11-min': [{
    delay: 0.79,
    duration: 0.03,
    to: {
      rotation: -Math.PI * 6,
      ease: Power1.easeInOut
    }
  }],
  's11-hour': [{
    delay: 0.79,
    duration: 0.03,
    to: {
      rotation: -Math.PI / 3,
      ease: Power1.easeInOut
    }
  }],
  's11-txt7': [{
    delay: 0.812,
    duration: 0.02,
    from: {
      alpha: 0
    }
  }],
  's12-dialog': [{
    delay: 0.898,
    duration: 0.01,
    from: {
      alpha: 0
    }
  }],
  's13-face1': [{
    delay: 0.969,
    duration: 0.01,
    to: {
      alpha: 0
    }
  }],
  's13-face2': [{
    delay: 0.97,
    duration: 0.01,
    from: {
      alpha: 0,
    },
    to: {
      alpha: 1
    }
  }, {
    delay: 0.98,
    duration: 0.01,
    to: {
      alpha: 0
    }
  }],
  's13-face3': [{
    delay: 0.974,
    duration: 0.01,
    from: {
      alpha: 0
    },
    to: {
      alpha: 1
    }
  }],
  's13-txt1': [{
    delay: 0.987,
    duration: 0.01,
    from: {
      alpha: 0
    },
    to: {
      alpha: 1
    }
  }],
  's13-slogan': [{
    delay: 0.992,
    duration: 0.02,
    from: {
      x: 19000
    }
  }],
  // 's13-qr': [{
  //   delay: 0.996,
  //   duration: 0.02,
  //   from: {
  //     x: 19000
  //   }
  // }]
}
